/*
 * File: c:\Users\l.haddad\Desktop\MOBYBUY\mobybuy_backoffice\src\Content\Modals\ModalTransferUser\ModalTransferUser.tsx
 * Project: c:\Users\l.haddad\Desktop\MOBYBUY\mobybuy_backoffice
 * Created Date: Friday June 20th 2025
 * Author: Tommy Boisseau
 * -----
 * Last Modified: Friday June 20th 2025 5:01:38 pm
 * Modified By: the developer formerly known as Tommy Boisseau at <t.boisseau@autobuy.fr>
 * -----
 * Copyright (c) 2025 Autobuy SAS
 * -----
 */

import { Dispatch, SetStateAction, useState } from "react";
import Styles from "Content/Modals/ModalMakeOffer/ModalMakeOffer.module.css";
import MyModal from "Content/Modals/MyModal";
import translator from "MultiLanguage/TranslationWrapper";
import SelectCommercial from "Content/User/Commercials/SelectCommercial";
import { ModalConfirmRequest } from "../ModalConfirmRequest/ModalConfirmRequest";
import UserService from "Services/Users/UserService";
import ModalConfirmation from "../ModalConfirmation/ModalConfirmation";
import { UserSimple } from "Type/user.type";

type ModalTransferUserProps = {
    show: boolean,
    onClose: () => void,
    oldCommercialID: string,
    setButtonEnable?: Dispatch<SetStateAction<boolean>>
};

export function ModalTransferUser(props: ModalTransferUserProps) {
    const [isOkay, setIsOkay] = useState<boolean>(false);
    const [showConfirmRequestModal, setShowConfirmRequestModal] = useState<boolean>(false);
    const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false);
    const [newCommercial, setNewCommercial] = useState<UserSimple>();

    const closeConfirmRequestModal = () => {
        setShowConfirmRequestModal(false);
    }

    const closeConfirmModal = () => {
        setShowConfirmModal(false);
        setShowConfirmRequestModal(false);
        props.onClose();
        window.location.reload();
    }

    const manageSetter = (IsOkay: boolean, OpenModal: boolean, ButtonEnable: boolean) => {
        setIsOkay(IsOkay);
        setShowConfirmModal(OpenModal);
        props.setButtonEnable?.(ButtonEnable);
    };

    const handleTransferUsers = () => {
        if (!newCommercial)
            return;
        props.setButtonEnable?.(false);
        UserService.updateCommercialUser(props.oldCommercialID, newCommercial.id).then((res) => {
            manageSetter(true, true, true);
        }).catch(() => {
            manageSetter(false, true, true);
        });
    }

    return (
        <>
            <MyModal closeModal={props.onClose} show={props.show} onClose={props.onClose} addCloseCross={true} footer={(() => { return (<></>); })()} title={translator.decode('dynamic.chooseCommercialMessage')} className={Styles.modalCtaStyle}>
                <div className={`${Styles.modal}`}>
                    {props.oldCommercialID && (
                        <div className="mb-3">
                            <SelectCommercial setNewCommercial={setNewCommercial} valueName="value" onUpdate={() => { } } className={Styles.select} filteredCommercialID={props.oldCommercialID} label={translator.decode("dynamic.commercial")} />
                        </div>
                    )}
                    <div>
                        <button className="btn btn-danger" onClick={props.onClose}>{translator.decode("dynamic.cancel")}</button>
                        <button className="btn btn-success ms-3" onClick={() => setShowConfirmRequestModal(true)}>{translator.decode("dynamic.confirm")}</button>
                    </div>
                </div>
            </MyModal>
            <ModalConfirmation show={showConfirmModal} onClose={closeConfirmModal} closeModal={closeConfirmModal} isOkay={isOkay} />
            <ModalConfirmRequest show={showConfirmRequestModal} onClose={closeConfirmRequestModal} closeModal={closeConfirmRequestModal} request={() => handleTransferUsers()} title={translator.decode("dynamic.additionalMessageCommercial").replace("%nc", newCommercial?.FirstName + ' ' + newCommercial?.LastName )} />
        </>
    )
}
